module.exports = __webpack_public_path__ + "static/media/success.f751e49b.png";